import * as React from "react";
import { MemoryRouter as Router, Routes, Route } from "react-router-dom";

import Frame from "../../components/ui/Frame";
import EquityDataForm from "../../components/new-link-builder/equity-data/NewLinkBuilderForm";
import CurrencyDataForm from "../../components/new-link-builder/currency-data/NewLinkBuilderForm";
import CompanyDataForm from "../../components/new-link-builder/company-data/NewLinkBuilder";
import TradedFundsForm from "../../components/new-link-builder/traded-funds/NewLinkBuilder";
import UnAuthenticatedError from "../../components/UnAuthenticatedError";
import Actuals from "@/components/new-link-builder/actuals/Actuals";
import "@/styles/globals.css";
import CustomBuiltIndex from "@/components/new-link-builder/custom-built-index/CustomBuiltIndex";
import { useAuth } from "@/components/contexts/AuthContext";

const App: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  return (
    <>
      {isAuthenticated ? (
        <div style={{ minHeight: "100vh" }}>
          <Router>
            <Routes>
          <Route path="/" element={
            <Frame>
              <div>
                <h1>AlphaScript</h1>
              </div>
            </Frame>
          } />
          <Route path="/company-data" element={
            <Frame>
              <CompanyDataForm />
            </Frame>
          } />
          <Route path="/currency-data" element={
            <Frame>
              <CurrencyDataForm />
            </Frame>
          } />
          <Route path="/traded-funds" element={
            <Frame>
              <TradedFundsForm />
            </Frame>
          } />
          <Route path="/equity-data" element={
            <Frame>
              <EquityDataForm />
            </Frame>
          } />
          <Route path="/actuals" element={
            <Frame>
              <Actuals />
            </Frame>
          } />
          <Route path="/custom-built-index" element={
            <Frame>
              <CustomBuiltIndex />
            </Frame>
          } />
        </Routes>
      </Router>
    </div>
      ) : (
        <UnAuthenticatedError />
      )}
    </>
  );
};

export default App;
